import { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";

export default function SellerDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/seller/dashboard").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-sm text-neutral-500">Loading…</div>;
  const { stats, recent } = data;

  return (
    <div data-testid="seller-dashboard">
      <div className="admin-overline">Overview</div>
      <h1 className="admin-heading text-3xl sm:text-4xl font-bold tracking-tight mt-1 mb-6 sm:mb-8">Your jobs.</h1>

      <div className="stat-grid">
        {[
          { k: "total", l: "Total" },
          { k: "pending", l: "Pending" },
          { k: "completed", l: "Completed" },
          { k: "earnings", l: "Earnings", money: true },
        ].map((c) => (
          <div key={c.k} data-testid={`seller-stat-${c.k}`}>
            <div className="admin-overline">{c.l}</div>
            <div className="admin-heading text-2xl sm:text-3xl font-bold mt-1 break-anywhere">{c.money ? formatINR(stats[c.k] || 0) : (stats[c.k] || 0)}</div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-neutral-200 p-4 sm:p-6 mt-6 sm:mt-8">
        <div className="admin-overline mb-4">Recent jobs</div>
        {recent.length === 0 && <div className="py-6 text-center text-sm text-neutral-500">No jobs yet</div>}

        {/* Phones: one card per job */}
        <div className="md:hidden divide-y divide-neutral-100">
          {recent.map((b) => (
            <div key={b.id} className="py-3">
              <div className="flex justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-semibold text-sm break-words">{b.service_name}</div>
                  <div className="text-xs text-neutral-500 mt-0.5">{b.customer_name} · {b.scheduled_date}</div>
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="font-bold text-sm">{formatINR(b.total)}</div>
                  <div className="text-[11px] uppercase text-neutral-500">{b.status}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {recent.length > 0 && (
          <div className="hidden md:block table-scroll">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs text-neutral-500 border-b border-neutral-200">
                <th className="py-2">Code</th><th>Service</th><th>Customer</th><th>When</th><th>Status</th><th className="text-right">Total</th>
              </tr></thead>
              <tbody>
                {recent.map((b) => (
                  <tr key={b.id} className="border-b border-neutral-100">
                    <td className="py-2 font-mono text-xs">{b.code}</td>
                    <td>{b.service_name}</td>
                    <td className="text-xs">{b.customer_name}</td>
                    <td className="text-xs">{b.scheduled_date}</td>
                    <td className="text-xs uppercase">{b.status}</td>
                    <td className="text-right font-bold">{formatINR(b.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
